<div
  #chatContainer
  [ngStyle]="{
    'pointer-events': isLoadingMessages() ? 'none' : 'unset',
    cursor: isLoadingMessages() ? 'wait' : 'pointer'
  }"
  class="d-flex position-relative"
  p-tooltip="Chat"
>
  <po-loading-icon p-size="sm"
    *ngIf="isLoadingMessages()"
    [p-neutral-color]="false"
    class="small-loading"
  ></po-loading-icon>

  <i *ngIf="!isLoadingMessages()" class="an an-chats title-very-large-heavy cursor-pointer"></i>

  <div *ngIf="unread()?.count > 0" class="badge-pending-counter cursor-pointer">
    {{ unread()?.count }}
  </div>
</div>

<po-popover
  #popover
  [p-target]="chatContainer"
  class="popover-custom-width-3"
  p-position="bottom-left"
>
  <div (click)="$event.stopPropagation()">
    <mihmo-chat-container
      [isAttendanceVideo]="false"
      [isChatPopup]="true"
      [mihmadoSelected]="mihmadoSelected"
      [services]="true"
      [showChat]="true"
      [visualizationTabMenu]="false"
    >
    </mihmo-chat-container>
  </div>
</po-popover>
